export const areaResultTranslations = {
  noData: {
    key: 'areaResult.noData',
    defaultValue: 'No stores found!',
  },
  resultsBasedOn: {
    key: 'areaResult.resultsBasedOn',
    defaultValue: 'Results Based On:',
  },
  moreDetailsText: {
    key: 'areaResult.moreDetailsText',
    defaultValue: 'More Details...',
  },
  storeVisibility: {
    open: {
      key: 'areaResult.storeVisibility.open',
      defaultValue: 'Open',
    },
    closed: {
      key: 'areaResult.storeVisibility.closed',
      defaultValue: 'Closed',
    },
    future: {
      key: 'areaResult.storeVisibility.future',
      defaultValue: 'Future',
    },
    rejected: {
      key: 'areaResult.storeVisibility.rejected',
      defaultValue: 'Rejected',
    },
    tempClosed: {
      key: 'areaResult.storeVisibility.tempClosed',
      defaultValue: 'Temp Closed',
    },
    countryApproved: {
      key: 'areaResult.storeVisibility.countryApproved',
      defaultValue: 'Country Approved',
    },
    noStatus: {
      key: 'areaResult.storeVisibility.noStatus',
      defaultValue: 'No Status',
    },
  },
  storeDetailsModal: {
    storeDetailsText: {
      key: 'areaResult.storeDetailsModal.storeDetailsText',
      defaultValue: 'Store Details',
    },
    loadingText: {
      key: 'areaResult.storeDetailsModal.loadingText',
      defaultValue: 'Fetching Store Details...',
    },
    address: {
      key: 'areaResult.storeDetailsModal.address',
      defaultValue: 'Address',
    },
    storeManager: {
      key: 'areaResult.storeDetailsModal.storeManager',
      defaultValue: 'Store Manager',
    },
    noManagerText: {
      key: 'areaResult.storeDetailsModal.noManagerText',
      defaultValue: 'Manager information not found.',
    },
    services: {
      key: 'areaResult.storeDetailsModal.services',
      defaultValue: 'Services',
    },
    noServicesFound: {
      key: 'areaResult.storeDetailsModal.noServicesFound',
      defaultValue: 'No Services found for this store!',
    },
    noOpeningHourText: {
      key: 'areaResult.storeDetailsModal.noOpeningHourText',
      defaultValue: 'No Opening hours found for this store!',
    },
  },
  storeId: {
    key: 'areaResult.storeId',
    defaultValue: 'Store ID',
  },
  summary: {
    key: 'areaResult.summary',
    defaultValue: 'Summary',
  },
  summaryTypeText: {
    sum: {
      key: 'areaResult.summaryTypeText.sum',
      defaultValue: 'Summation',
    },
    grossAvg: {
      key: 'areaResult.summaryTypeText.grossAvg',
      defaultValue: 'Gross Average',
    },
  },
  breakdown: {
    key: 'areaResult.breakdown',
    defaultValue: 'View Breakdown',
  },
  customerBaseValue: {
    loading: {
      key: 'areaResult.customerBaseValue.loading',
      defaultValue: 'Fetching Customer Base Value Data...',
    },
    noData: {
      key: 'areaResult.customerBaseValue.noData',
      defaultValue: 'No Customer Base Value details found!',
    },
    activeCustomers: {
      key: 'areaResult.customerBaseValue.activeCustomers',
      defaultValue: 'Active Customers',
    },
    unrecruited: {
      key: 'areaResult.customerBaseValue.unrecruited',
      defaultValue: 'Unrecruited',
    },
    memberSoR: {
      key: 'areaResult.customerBaseValue.memberSoR',
      defaultValue: 'Member SoR',
    },
    appCustomers: {
      key: 'areaResult.customerBaseValue.appCustomers',
      defaultValue: 'App Customers',
    },
    recruitedCustomers: {
      key: 'areaResult.customerBaseValue.recruitedCustomers',
      defaultValue: 'Recruited Customers',
    },
    recruitedShare: {
      key: 'areaResult.customerBaseValue.recruitedShare',
      defaultValue: 'Recruited Share',
    },
  },
  salesEfficiency: {
    loading: {
      key: 'areaResult.salesEfficiency.loading',
      defaultValue: 'Fetching Sales Efficiency Data...',
    },
    noData: {
      key: 'areaResult.salesEfficiency.noData',
      defaultValue: 'No Sales Efficiency details found!',
    },
    sales: {
      key: 'areaResult.salesEfficiency.sales',
      defaultValue: 'Sales',
    },
    conversionRate: {
      key: 'areaResult.salesEfficiency.conversionRate',
      defaultValue: 'Conversion Rate',
    },
    takt1: {
      key: 'areaResult.salesEfficiency.takt1',
      defaultValue: 'Takt 1',
    },
  },
  customerExperience: {
    loading: {
      key: 'areaResult.customerExperience.loading',
      defaultValue: 'Fetching Customer Experience Data...',
    },
    noData: {
      key: 'areaResult.customerExperience.noData',
      defaultValue: 'No Customer Experience details found!',
    },
    hoursSpent: {
      key: 'areaResult.customerExperience.hoursSpent',
      defaultValue: 'Hours Spent',
    },
    noOfScanners: {
      key: 'areaResult.customerExperience.noOfScanners',
      defaultValue: 'No. of Scanners',
    },
    queueLength: {
      key: 'areaResult.customerExperience.queueLength',
      defaultValue: 'Queue Length',
    },
    approvalRate: {
      key: 'areaResult.customerExperience.approvalRate',
      defaultValue: 'Approval Rate',
    },
    addedSales: {
      key: 'areaResult.customerExperience.addedSales',
      defaultValue: 'Added Sales',
    },
    retaggedItems: {
      key: 'areaResult.customerExperience.retaggedItems',
      defaultValue: 'Retagged Rate',
    },
    negDiff: {
      key: 'areaResult.customerExperience.negDiff',
      defaultValue: 'Neg Diff',
    },
  },

  breakdownView: {
    loading: {
      key: 'areaResult.breakdownView.loading',
      defaultValue: 'Fetching breakdown data...',
    },
    error: {
      key: 'areaResult.breakdownView.error',
      defaultValue: 'Failed to fetch breakdown data...',
    },
    kpiNetSalesName: {
      key: 'areaResult.breakdownView.kpiNetSalesName',
      defaultValue: 'Net Sales',
    },
    kpiConversionRateName: {
      key: 'areaResult.breakdownView.kpiConversionRateName',
      defaultValue: 'Conversion Rate',
    },
    kpiQueueLengthName: {
      key: 'areaResult.breakdownView.kpiQueueLengthName',
      defaultValue: 'Queue Length',
    },
    kpiShareOfReceiptsName: {
      key: 'areaResult.breakdownView.kpiShareOfReceiptsName',
      defaultValue: 'Share of Receipts',
    },
    kpiUnrecruitedName: {
      key: 'areaResult.breakdownView.kpiUnrecruitedName',
      defaultValue: 'Unrecruited',
    },
  },
};
